import { render, staticRenderFns } from "./course-guides-manage.vue?vue&type=template&id=22a25b5f"
import script from "./course-guides-manage.vue?vue&type=script&lang=js"
export * from "./course-guides-manage.vue?vue&type=script&lang=js"
import style0 from "./course-guides-manage.vue?vue&type=style&index=0&id=22a25b5f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports